import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Morphs made-to-order content when the selected product variant changes.
 */
class TavernMtoContent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = String(newProduct.id);
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const key = this.dataset.mtoKey;
        if (!key) return;

        const next = html.querySelector(`tavern-mto-content[data-mto-key="${key}"]`);
        if (!next) return;

        morph(this, next, { childrenOnly: true });
        if (next.dataset.mtoState) {
          this.dataset.mtoState = next.dataset.mtoState;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[tavern-mto] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('tavern-mto-content')) {
  customElements.define('tavern-mto-content', TavernMtoContent);
}
